import { render, staticRenderFns } from "./Dairy_Factory.vue?vue&type=template&id=59b68e8c&scoped=true"
import script from "./Dairy_Factory.vue?vue&type=script&lang=js"
export * from "./Dairy_Factory.vue?vue&type=script&lang=js"
import style0 from "./Dairy_Factory.vue?vue&type=style&index=0&id=59b68e8c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59b68e8c",
  null
  
)

export default component.exports